export const HOME_SEND_MAIL_BEGIN = 'HOME_SEND_MAIL_BEGIN';
export const HOME_SEND_MAIL_SUCCESS = 'HOME_SEND_MAIL_SUCCESS';
export const HOME_SEND_MAIL_FAILURE = 'HOME_SEND_MAIL_FAILURE';
export const HOME_SEND_MAIL_DISMISS_ERROR = 'HOME_SEND_MAIL_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js